const locale = {
  id : {
    blocker: {
      not_supported_browser: {
        title: 'Perangkatmu nggak mendukung.',
        subtitle: 'Silakan perbarui browsermu, atau download aplikasi Vidio.',
        additional_cta: 'Laporkan Masalah',
      },
      geoblock: {
        title: 'Konten tidak tersedia di negara kamu',
        subtitle:
          'Masih banyak konten menarik lainnya yang bisa kamu nikmati di Vidio, lho!',
        cta: 'Cari konten lain',
        additional_cta: 'Info Lengkap',
      },
      network_error: {
        title: 'Masalah pada jaringan',
        subtitle: 'Ada kendala saat terhubung ke Vidio. Coba lagi nanti, ya.',
        cta: 'Coba Lagi',
        additional_cta: 'Detail Error',
      },
      media_error: {
        title: 'Terjadi kesalahan saat memproses media',
        subtitle: 'Silakan coba lagi dengan perangkat lain',
        cta: 'Laporkan Masalah',
        additional_cta: 'Detail Error',
      },
      drm: {
        title: 'Perangkatmu nggak mendukung DRM',
        subtitle:
          'Coba lagi dengan perangkat yang mendukung atau cari hiburan lain di Vidio, yuk.',
        cta: 'Jelajahi Vidio',
        additional_cta: 'Info Lengkap',
      },
      general_error: {
        title: 'Terjadi gangguan nih',
        subtitle: 'Tunggu selagi kami mengatasinya dan coba lagi nanti, ya!',
        cta: 'Coba Lagi',
        additional_cta: 'Laporkan Masalah',
      },
      fetching_error: {
        title: 'Terjadi gangguan nih',
        subtitle: 'Tunggu selagi kami mengatasinya dan coba lagi nanti, ya!',
        cta: 'Coba Lagi',
        additional_cta: 'Laporkan Masalah',
      },
      media_not_supported: {
        title: 'Terdapat kendala pada perangkatmu',
        subtitle: 'Silakan coba lagi dengan perangkat lain.',
        cta: 'Laporkan Masalah',
        additional_cta: 'Detail Error',
      },
      hdcp: {
        title: 'Konten nggak bisa diputar',
        subtitle:
          'Perangkatmu nggak mendukung HDCP. Gunakan perangkat lain atau cari hiburan lain.',
        cta: 'Jelajahi Vidio',
        additional_cta: 'Info Lengkap',
      },
      adult: {
        title: 'Konten dewasa dan sensitif',
        subtitle: 'Video ini berisi konten yang tidak sesuai untuk remaja dan anak-anak.',
        cta: 'Saya Sudah Dewasa',
        signInCta: 'Masuk',
      },
      sign_in: {
        description: 'Sign in untuk menonton video ini',
        cta: 'Sign In',
      },
      chrome_version: {
        title: 'Update browser-mu dulu, ya',
        subtitle: 'Pastikan kamu menggunakan Google Chrome versi terbaru.',
      },
    }
  },
  en: {
    blocker: {
      not_supported_browser: {
        title: 'Your browser is not supported.',
        subtitle: 'Please update your browser or download our apps.',
        additional_cta: 'Report Problem',
      },
      geoblock: {
        title: 'Content not available in your country',
        subtitle: 'You can find many other things to enjoy on Vidio!',
        cta: 'Explore Vidio',
        additional_cta: 'More Info',
      },
      network_error: {
        title: 'Network error',
        subtitle:
          "There's a problem connecting to Vidio. Please try again later.",
        cta: 'Retry',
        additional_cta: 'Error Details',
      },
      media_error: {
        title: 'An error occurred while processing the media',
        subtitle: 'Please try again with another device',
        cta: 'Report Problem',
        additional_cta: 'Error Details',
      },
      drm: {
        title: 'This content can\’t be played',
        subtitle:
          'Your device doesn\’t support DRM. Please use another device or browse other content.',
        cta: 'Find Other Content',
        additional_cta: 'More Info',
      },
      general_error: {
        title: 'Oops, something went wrong',
        subtitle: 'Sit tight while we get things fixed and try again later.',
        cta: 'Retry',
        additional_cta: 'Report Problem',
      },
      fetching_error: {
        title: 'Oops, something went wrong',
        subtitle: 'Sit tight while we get things fixed and try again later.',
        cta: 'Retry',
        additional_cta: 'Report Problem',
      },
      media_not_supported: {
        title: 'Problem with your device',
        subtitle: 'Please try again with another device.',
        cta: 'Report Problem',
        additional_cta: 'Error Details',
      },
      hdcp: {
        title: "This content can't be played",
        subtitle:
          "Your device doesn’t support HDCP. Please use another device or browse other content.",
        cta: 'Explore Vidio',
        additional_cta: 'More Info',
      },
      adult: {
        title: 'Adult and sensitive contents',
        subtitle: 'This video contains adult content which is not appropriate for teenagers and kids.',
        cta: 'I am an adult',
        signInCta: 'Sign In',
      },
      sign_in: {
        description: 'Sign in to watch this video',
        cta: 'Sign In',
      },
      chrome_version: {
        title: 'Please update your browser',
        subtitle: 'Make sure you are using the latest version of Google Chrome.',
      },
    }
  }
}

export default locale;
